// Cruise Vibes — shared test IDs.
// Keys camelCase, values kebab-case <feature>-<element>.

export const NAV = {
    logo: 'nav-logo',
    home: 'nav-home',
    destinations: 'nav-destinations',
    packages: 'nav-packages',
    things: 'nav-things-to-do',
    groups: 'nav-groups',
    hotels: 'nav-hotels',
    lines: 'nav-cruise-lines',
    book: 'nav-book-cta',
    login: 'nav-login',
    dashboard: 'nav-dashboard',
    admin: 'nav-admin',
    logout: 'nav-logout',
    mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
    section: 'hero-section',
    bookBtn: 'hero-book-btn',
    destBtn: 'hero-destinations-btn',
};

export const HOME = {
    whyCards: 'home-why-cards',
    destPreview: 'home-destinations-preview',
    packagePreview: 'home-packages-preview',
    party: 'home-party-section',
    reviews: 'home-reviews',
    leadForm: 'home-lead-form',
    leadSubmit: 'home-lead-submit',
};

export const DEST = {
    section: 'destinations-section',
    card: (id) => `destinations-card-${id}`,
};

export const PKG = {
    section: 'packages-section',
    card: (id) => `packages-card-${id}`,
    reserve: (id) => `packages-reserve-${id}`,
};

export const RES = {
    page: 'reservation-page',
    step1: 'reservation-step-1',
    step2: 'reservation-step-2',
    step3: 'reservation-step-3',
    step4: 'reservation-step-4',
    step5: 'reservation-step-5',
    next: 'reservation-next-btn',
    back: 'reservation-back-btn',
    summary: 'reservation-summary',
    payDeposit: 'reservation-pay-deposit',
    payFull: 'reservation-pay-full',
    destination: 'reservation-destination',
    departure: 'reservation-departure',
    cruiseLine: 'reservation-cruise-line',
    package: 'reservation-package',
    cabin: 'reservation-cabin',
    guests: 'reservation-guests',
    contactName: 'reservation-contact-name',
    contactEmail: 'reservation-contact-email',
    contactPhone: 'reservation-contact-phone',
};

export const CHAT = {
    toggle: 'chat-toggle',
    panel: 'chat-panel',
    input: 'chat-input',
    send: 'chat-send',
    messages: 'chat-messages',
};

export const DASH = {
    page: 'dashboard-page',
    trips: 'dashboard-trips',
};

export const ADMIN = {
    page: 'admin-page',
    stats: 'admin-stats',
    leads: 'admin-leads',
    reservations: 'admin-reservations',
};
